export default __webpack_public_path__ + "static/media/emptyActivity.bf659178.svg";